/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Internal_Code_EditInputs */

const vi_order_internal_code_edit = /** @type {(inputs: Order_Internal_Code_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa mã đơn nội bộ`)
};

/**

* @param {Order_Internal_Code_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_internal_code_edit = /** @type {((inputs?: Order_Internal_Code_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Internal_Code_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_internal_code_edit(inputs)
});